import { lazy, LazyExoticComponent } from 'react'

type RouteType = {
  path: string
  exact: boolean
  component: LazyExoticComponent<any>
}

export const routes: RouteType[] = [
  {
    path: '/',
    exact: true,
    component: lazy(() => import('./pages/Login')),
  },
  {
    path: '/login',
    exact: true,
    component: lazy(() => import('./pages/Login')),
  },
  {
    path: '/404',
    exact: true,
    component: lazy(() => import('./pages/NotFound')),
  },
  {
    path: '/group',
    exact: true,
    component: lazy(() => import('./pages/Group')),
  },
  {
    path: '/:type/:id/permission',
    exact: true,
    component: lazy(() => import('./pages/Permission')),
  },
  {
    path: '/group/:id/project',
    exact: true,
    component: lazy(() => import('./pages/Project')),
  },
  {
    path: '/project/:id/history',
    exact: true,
    component: lazy(() => import('./pages/Project/history')),
  },
  {
    path: '/namespace/:id/history',
    exact: true,
    component: lazy(() => import('./pages/Namespace/history')),
  },
  {
    path: '/project/:id/namespace',
    exact: true,
    component: lazy(() => import('./pages/Namespace')),
  },
  {
    path: '/messages',
    exact: true,
    component: lazy(() => import('./pages/Messages')),
  },
  {
    path: '/test',
    exact: true,
    component: lazy(() => import('./pages/Test')),
  },
]
